import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import CheckIcon from '@mui/icons-material/Check';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { observer } from 'mobx-react';
import { SdkStore } from '@gamiphy/loyalty-station-desktop/store/sdk';

type DiscountButtonProps = {
  onCopy: () => void;
  copied: boolean;
  discountCode: string;
};

const DiscountButton: React.FC<DiscountButtonProps> = observer(({
  onCopy,
  copied,
  discountCode,
}) => {
  const { t } = useTranslation();
  const endIcon = copied ? <CheckIcon fontSize="large" /> : <FileCopyIcon fontSize="large" />;
  const applied = React.useMemo(() => SdkStore.cart?.data?.discountCodes.includes(discountCode), [
    SdkStore.cart?.data,
    discountCode,
  ]);

  switch (true) {
    case applied:
      return (
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          disabled
        >
          {t('redeemHistory.applied', 'Applied')}
        </Button>
      );
    default:
      return (
        <Button
          variant="contained"
          color="secondary"
          onClick={onCopy}
          endIcon={endIcon}
          fullWidth
        >
          {discountCode}
        </Button>
      );
  }
});

export default DiscountButton;
